import { ns } from '@/helpers/store';
import store from '@/store'; // eslint-disable-line import/no-cycle
import { UPDATE_LEGACY_SETTINGS } from '@/store/types/actions';
import { PERSISTENCE_ACCOUNT_SET, PERSISTENCE_SET } from '@/store/types/mutations';
import { SETTINGS } from '@/store/types/namespaces';

const mutations = {
  [PERSISTENCE_ACCOUNT_SET](state, settings) {
    const uiDarkMap = {
      true: 'dark',
      false: 'light',
    };

    state.dashboardId = settings.userSettings['ui.dashboard'];
    state.dashboardFilter = settings.userSettings['ui.dashboard.filterFilter'];
    state.lastReadReleaseNotes = settings.userSettings['ui.lastReadReleaseNotes'] || 0;
    state.viewDataPeriod = settings.userSettings['ui.viewDataPeriod'] || null;
    state.theme = (settings.userSettings.uiDark === undefined
      || settings.userSettings.theme === 'system')
      ? 'system'
      : uiDarkMap[settings.userSettings.uiDark];
    state.uiDark = state.theme === 'system'
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
      : settings.userSettings.uiDark;
    state.historyChartHidden = settings.userSettings['ui.view.historyChart.hidden'] || [];
    state.mapDrawRadius = settings.userSettings['ui.view.map.drawRadius'] || {
      enabled: false,
      radius: 1000,
    };
  },
  [PERSISTENCE_SET](state, { key, value, multiple }) {
    if (Array.isArray(multiple)) {
      multiple.forEach(({ key: k, value: v }) => {
        state[k] = v;
      });
    } else {
      state[key] = value;
    }

    const settings = {
      'ui.dashboard': state.dashboardId,
      'ui.dashboard.filterFilter': state.dashboardFilter,
      'ui.lastReadReleaseNotes': state.lastReadReleaseNotes,
      'ui.viewDataPeriod': state.viewDataPeriod,
      'ui.view.historyChart.hidden': state.historyChartHidden,
      'ui.map.drawRadius': state.mapDrawRadius,
      theme: state.theme,
      uiDark: state.uiDark,
    };
    store.dispatch(ns(SETTINGS, UPDATE_LEGACY_SETTINGS), settings);
  },
};

export default {
  namespaced: true,
  state: {
    theme: 'system',
    uiDark: false,
    lastReadReleaseNotes: 0,
    viewDataPeriod: null,
    historyChartHidden: [],
    mapDrawRadius: {
      enabled: true,
      radius: 1000,
    },
  },
  mutations,
};
